export const AI_TRIP_PLANNER_NAV_ID = 'ai-trip-planner-nav-link'
